import { useIsProfileContextMutating } from "@/entities/profile";
import {
  useOrganizationContext,
  useOrganizationContextDetail,
  useOrganizationContextList,
} from "@/modules/organization/organization-context";

export const useOrganizationContextLoader = () => {
  const { isLoading } = useOrganizationContext();
  const { isLoading: isListLoading } = useOrganizationContextList();
  const { isLoading: isDetailLoading } = useOrganizationContextDetail();
  const isMutating = useIsProfileContextMutating();

  return isLoading || isListLoading || isDetailLoading || isMutating;
};
